module.exports = __webpack_public_path__ + "img/plug-solid.f7d842e4.svg";